declare namespace $ {

	export class $bog_favicon extends $mol_plugin {
		Icon( ): $mol_view
	}
	
}

//# sourceMappingURL=favicon.view.tree.d.ts.map